/**
 * @file 日志模块
 * @author congpeisen@baidu.com
 * @description 交互日志接入bend-sdk、性能日志todo
 */

/* global swan getApp */
/* eslint-disable */

// const TC_URL = 'https://m.baidu.com/tc';

// const _send = conf => {
//     const img = new Image();
//     img.src = `${TC_URL}?${core.getQueryStr(conf)}`;
// };

// export const sendLog = userConf => {
//     const {
//         pd,
//         lid,
//         applid,
//         referlid
//     } = getApp().globalData.log;

//     let conf = {
//         tcreq4log: 1,
//         module: "h5" === 'swan'
//                     ? 'swan'
//                     : "h5" === 'h5' ? 'sf' : '',
//         pd,
//         lid,
//         clk_info: {
//             type: userConf.type,
//             action: userConf.action,
//             t: Date.now(),
//             applid,
//             referlid
//         },
//         extra: userConf.extra || {}
//     };

//     Object.getOwnPropertyNames(conf).map(key => {
//         let val = conf[key];
//         conf[key] = core.isObject(val) ? JSON.stringify(val) : val;
//         return val;
//     });

//     _send(conf);
// };

export let sendLog = (mod, options = {}) => {
  let log;
  let env = "h5";
  let ext = {};
  ext.platform = 'h5';
  Object.assign(ext, options);
  log = window.bendSDKLog.log;
  log.sendClickLog({
    mod: env + '-' + mod,
    ext
  });
};